import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SERVER_URL } from '@src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RadiantService {
  constructor(private http: HttpClient) {}

  get<T>(endpoint: string): Observable<T> {
    return this.http.get<T>(`${SERVER_URL}/${endpoint}`);
  }

  getAll<T>(endpoint: string): Observable<T[]> {
    return this.http.get<T[]>(`${SERVER_URL}/${endpoint}`);
  }

  getAllByRefType<T>(endpoint: string, ref_type: string, id: number): Observable<T[]> {
    return this.http.get<T[]>(`${SERVER_URL}/${endpoint}/${ref_type}/${id}`);
  }

  getById<T>(endpoint: string, id: number): Observable<T> {
    return this.http.get<T>(`${SERVER_URL}/${endpoint}/${id}`);
  }

  create<T>(endpoint: string, data: any): Observable<T> {
    return this.http.post<T>(`${SERVER_URL}/${endpoint}`, data);
  }

  update<T>(endpoint: string, id: number, data: any): Observable<T> {
    return this.http.put<T>(`${SERVER_URL}/${endpoint}/${id}`, data);
  }

  delete(endpoint: string, id: number): Observable<boolean> {
    return this.http.delete<boolean>(`${SERVER_URL}/${endpoint}/${id}`);
  }
}
